import { Select } from 'antd';
import React from 'react';

interface statusFilter {
  title: string;
  value: string;
}

interface Props {
  //state
  searchBy: statusFilter[];
  // filter
  handleFilterValue: Function;
}
const { Option } = Select;

const DropdownFilter = ({ searchBy, handleFilterValue }: Props) => {
  const handleChange = (value: { value: string; label: React.ReactNode }) => {
    handleFilterValue(value.value);
  };
  return (
    <Select
      labelInValue
      // defaultValue={{ value: searchBy[0].value, label: searchBy[0].title }}
      placeholder="선택"
      onChange={handleChange}
    >
      {(searchBy || []).map((item) => (
        <Option key={item.value} value={item.value}>{item.title}</Option>
      ))}
    </Select>
  );
};

export default DropdownFilter;
